import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SystemPropertiesService } from '@app/core/services/system-properties.service';
import { APP_CONSTANTS } from '@app/services/common/app-constants';
import { CheckTeamMembersService } from '@app/services/common/check-team-members.service';
import { sharePointURL } from '@app/services/common/utils';
import { SystemPropertyKey } from '@common/enums/SystemPropertyKey';

@Component({
  selector: 'app-required-members-dialog',
  templateUrl: './required-members-dialog.component.html',
  styleUrls: ['./required-members-dialog.component.scss']
})
export class RequiredMembersDialogComponent implements OnInit {
  listName: string;
  @Input() visible: boolean = false;
  @Input() company;
  @Output() visibleChange = new EventEmitter<boolean>(); 
  @Output() closed = new EventEmitter<void>();
  constructor(private readonly systemPropertiesService: SystemPropertiesService, private readonly checkTeamMembersService: CheckTeamMembersService) { }

  ngOnInit(): void {
    this.systemPropertiesService.getByKey<string>(SystemPropertyKey.portfolioCompanyMasterList).subscribe((res) => {
      this.listName = res;
    });
  }

  get sharePointURL() {
    return sharePointURL(this.listName, APP_CONSTANTS.SHAREPOINT_VIEW_ID.PortfolioCompanyQuiltDev, this.company?.mnemonic);
  }
  onHide() {
    this.visibleChange.emit(false);
    this.closed.emit();
  }
  getMissingTeamRolesString(){
    return this.checkTeamMembersService.getMissingTeamRolesString(this.company) ;
  }
}
